import React, { useState } from 'react';
import { ChevronDown } from '../../../../assets/icons/ChevronDown';
import { CircleCrossSmallIcon } from '../../../../assets/icons/CircleCrossSmallIcon';
import { CircleTickFilledIcon } from '../../../../assets/icons/CircleTickFilledIcon';

export interface AccordionPanel {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  subtitle?: string;
}

export interface ProtectionDetailsAccordionPanelWibProps {
  panels?: AccordionPanel[];
  isDesktop?: boolean;
  warrantyLength?: number;
  currentWarrantyLabel?: string;
  quoteCoverageLabel?: string;
}

const styles = {
  headingLabel:
    'text-body-small-strong text-neutral-900 text-center w-17.5 flex items-center justify-center',
};

export function BenefitsTableAccordion({
  panels = [],
  warrantyLength,
}: ProtectionDetailsAccordionPanelWibProps) {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const togglePanel = (index: number) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  const warrantyInYears = warrantyLength ? Math.floor(warrantyLength / 12) : 0;

  return (
    <>
      <div className="flex justify-end gap-4 mb-2 pr-1">
        <h5 className={styles.headingLabel}>Current Warranty</h5>
        <h5 className={styles.headingLabel}>Extra Coverage</h5>
      </div>

      {panels.map((panel, index) => {
        const expanded = expandedIndex === index;
        return (
          <div
            key={index}
            className={`flex items-start w-full cursor-pointer
              ${index === 0 ? 'py-space-300' : 'py-space-300 border-t border-card-border-neutral'}`}
            onClick={() => togglePanel(index)}
            role="button"
            aria-expanded={expanded}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                togglePanel(index);
              }
            }}
          >
            <div className="flex flex-col w-full">
              <div className="flex flex-row items-baseline w-full">
                <ChevronDown
                  isOpen={expanded}
                  className="text-neutral-900 text-body-strong transition-transform duration-250 linear mr-space-200 shrink-0"
                  aria-hidden="true"
                />

                <div className="flex flex-col flex-1">
                  <p className="text-left text-neutral-900 wrap-break-word text-body-strong align-baseline">
                    {panel.title}
                  </p>
                </div>

                <div
                  className={`flex flex-row ${index === 0 ? 'items-start' : 'items-center'} gap-space-400 pl-space-200 md:pl-0`}
                >
                  {index === 0 ? (
                    <>
                      <span className="w-20 flex flex-col items-center">
                        <CircleTickFilledIcon aria-hidden="true" />
                        {warrantyInYears > 0 && (
                          <p className="mt-space-200 text-body-small  text-neutral-900 text-nowrap">
                            {warrantyInYears} year{warrantyInYears > 1 ? 's' : ''} only
                          </p>
                        )}
                      </span>
                      <span className="w-20 flex flex-col items-center">
                        <CircleTickFilledIcon aria-hidden="true" />
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="w-20 flex flex-col items-center">
                        <CircleCrossSmallIcon aria-hidden="true" />
                      </span>
                      <span className="w-20 flex flex-col items-center">
                        <CircleTickFilledIcon aria-hidden="true" />
                      </span>
                    </>
                  )}
                </div>
              </div>

              {expanded && panel.description && (
                <div className="w-full pl-space-600 mt-space-200">
                  <p className="text-neutral-900">{panel.description}</p>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}
